import createFetchClient, { type ClientOptions } from 'openapi-fetch'
import {
    createImmutableHook,
    createInfiniteHook,
    createMutateHook,
    createQueryHook,
} from 'swr-openapi'

const cacheKey = 'netdata-agent-swr' as const

export type NetdataAgentPaths = import('../../types.agent.d.ts').paths

/**
 * Creates SWR hooks that speak to the Netdata Agent API.
 * Quick start:
 *   const swr = createAgentSWR({ baseUrl: "http://localhost:19999" });
 *   const { data } = swr.useQuery("/api/v3/nodes");
 */
export default function createAgentSWR(options: ClientOptions = {}): {
    useQuery: ReturnType<typeof createQueryHook<NetdataAgentPaths, any, 'netdata-agent-swr'>>
    useImmutable: ReturnType<
        typeof createImmutableHook<NetdataAgentPaths, any, 'netdata-agent-swr'>
    >
    useInfinite: ReturnType<
        typeof createInfiniteHook<NetdataAgentPaths, any, 'netdata-agent-swr'>
    >
    useMutate: ReturnType<typeof createMutateHook<NetdataAgentPaths, any>>
} {
    const client = createFetchClient<NetdataAgentPaths>(options)

    return {
        useQuery: createQueryHook(client, cacheKey),
        useImmutable: createImmutableHook(client, cacheKey),
        useInfinite: createInfiniteHook(client, cacheKey),
        useMutate: createMutateHook(client, cacheKey, (a, b) => a === b),
    }
}
